'use client'

import { TableSize } from '@/components/common/table-size'
import { ErrorBoundary } from '@/components/common/error-boundary'

import { useTranslations } from 'next-intl'
import { useProductDetailSafe } from '../../context/product-detail-context'
import { GuideNote } from './guide-note'

interface Props {
  sizeChart?: string
}
export const ProductSizeInfo = ({ sizeChart }: Props) => {
  const { product } = useProductDetailSafe()
  const t = useTranslations('product_detail.size_chart')

  if (!product.size_guide) return null

  const sizeData = product.size_guide

  const isBraOrLegging = sizeChart && ['BRA', 'LEGGING'].includes(sizeChart)
  return (
    <div className='mt-4'>
      {isBraOrLegging && (
        <div className='text-base font-bold uppercase'>
          {t('product_specifications')}
        </div>
      )}

      <p className='mb-2 text-sm text-neutral-600'>{t('measurement_note')}</p>
      <ErrorBoundary
        fallback={
          <div className='mt-2 text-center text-sm text-error-500'>
            Có lỗi xảy ra khi hiển thị bảng size
          </div>
        }
      >
        <TableSize
          rows={sizeData.rows}
          columns={sizeData.columns}
          matrix={sizeData.matrix}
          headerTitle={sizeData.headerTitle}
          leftTitle={sizeData.leftTitle}
          colClassName='min-w-32 text-start'
        />
      </ErrorBoundary>
        <GuideNote />
    </div>
  )
}
